export default __webpack_public_path__ + "static/media/Anas.cb2661ca.svg";